/* motion.js — bidirectional scroll reveals, direction-aware entrances,
   smart hiding header, cart badge pop. All motion is disabled under
   prefers-reduced-motion and degrades safely without JS. */
(function () {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll direction tracking ---------- */
  let lastY = window.scrollY;
  let dir = 'down';
  function trackDirection() {
    const y = window.scrollY;
    if (Math.abs(y - lastY) > 4) {
      dir = y > lastY ? 'down' : 'up';
      document.documentElement.setAttribute('data-scroll-dir', dir);
      lastY = y;
    }
  }

  /* ---------- Scroll reveal (repeats in both directions) ---------- */
  const TARGETS = [
    '.product-card',
    '.category-tile',
    '.trust-strip__item',
    '.review-card',
    '.blog-card',
    '.section-header',
    '.newsletter',
    '.search-other-item',
    '.status-stage',
  ].join(',');

  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting) {
            const siblings = Array.from(el.parentElement ? el.parentElement.children : []);
            const idx = Math.max(0, siblings.indexOf(el.closest('li') || el));
            el.style.transitionDelay = `${Math.min(idx % 10, 6) * 45}ms`;
            el.classList.add('is-visible');
          } else if (entry.boundingClientRect.top > window.innerHeight || entry.boundingClientRect.bottom < 0) {
            // fully out of view — reset so it animates again on re-entry
            el.style.transitionDelay = '0ms';
            el.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -20px 0px' }
    );

    document.querySelectorAll(TARGETS).forEach((el) => {
      // elements in the initial viewport stay static — no flash on load
      if (el.getBoundingClientRect().top > window.innerHeight * 0.92) {
        el.classList.add('reveal');
        io.observe(el);
      }
    });
  }

  /* ---------- Header: always-sticky, with shadow once scrolled ---------- */
  function initHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let ticking = false;

    const update = () => {
      trackDirection();
      header.classList.toggle('is-scrolled', window.scrollY > 6);
      // Navbar stays pinned at all times — no hide-on-scroll-down.
      header.classList.remove('site-header--hidden');
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- Cart badge pop on update ---------- */
  function initBadgePop() {
    let lastCount = null;
    document.addEventListener('cart:updated', (e) => {
      const count = e.detail && e.detail.item_count;
      if (lastCount !== null && count !== lastCount) {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.classList.remove('cart-count--pop');
          void el.offsetWidth; // restart animation
          el.classList.add('cart-count--pop');
        });
      }
      lastCount = count;
    });
  }

  const boot = () => {
    initReveal();
    initHeader();
    initBadgePop();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
